import React, { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { Divider } from './Divider';
import { FeedActivityGroup } from './FeedActivityGroup';
import { PaddingContainer } from './shared';
import { ActivityFeedState } from './store';
import type { ActivityGroupWithDivider } from './store';

export const FeedItemContent = ({
  index,
  item,
}: {
  index: number;
  item: ActivityGroupWithDivider;
}) => {
  const { inView, ref } = useInView({ rootMargin: '-45% -5px' });
  const timeStamp = item.latestActivityOccurenceAt;

  useEffect(() => {
    if (inView) {
      ActivityFeedState.scrollIndex = index;
    }
  }, [inView, index]);

  return (
    <div ref={ref}>
      <PaddingContainer>
        <Divider date={item.isSameDay ? undefined : new Date(timeStamp)} />
      </PaddingContainer>
      <FeedActivityGroup item={item} />
    </div>
  );
};
